import React, { useEffect, useRef, useState } from 'react';
import TextInput from '../../common/TextInput/TextInput';
import SearchBarOptions from './SearchBarOptions';
import { SearchOptions } from './types';
import { Icon } from '../../common';
import { COLOURS } from '../../../utils/consts';
import { useDebounce } from 'use-debounce';

import './searchBar.css';

type SearchBarInputProps = {
    error?: string | null;
    placeholder?: string;
    startSearch: (value: string) => void;
    isLoading: boolean;
    results: SearchOptions | null;
    isDisabled?: boolean;
    onCloseClick: () => void;
};

const SearchBarInput = ({
    placeholder = '',
    error = null,
    startSearch,
    isLoading = false,
    results,
    isDisabled = false,
    onCloseClick,
}: SearchBarInputProps) => {
    const [inputValue, setInputValue] = useState('');
    const [openMenu, setOpenMenu] = useState(false);
    const searchMenu = useRef<HTMLElement | null>();

    const [debouncedValue] = useDebounce(inputValue, 1000);

    useEffect(() => {
        if (debouncedValue) {
            startSearch(debouncedValue);
            setOpenMenu(true);
        }
    }, [debouncedValue]);

    const showOptionsHandler = (event: any) => {
        event.preventDefault();
        event.stopPropagation();

        if (inputValue) {
            setOpenMenu(!openMenu);
        }
    };

    const closeMenu = (_: React.FocusEvent<HTMLButtonElement>) => {
        setTimeout(() => {
            if (searchMenu.current) {
                setOpenMenu(false);
            }
        }, 100);
    };

    const inputChangeHandler = (_: string, value: string) => {
        if (!value) {
            setOpenMenu(false);
        }
        setInputValue(value);
    };

    return (
        <>
            <button
                className="search-bar-container"
                onBlur={closeMenu}
                onClick={showOptionsHandler}
                ref={element => {
                    searchMenu.current = element;
                }}
            >
                <TextInput
                    iconName="bx-search"
                    value={inputValue}
                    type="text"
                    onChange={inputChangeHandler}
                    name="searchBarInput"
                    placeholder={placeholder}
                    isDisabled={isDisabled}
                    autoComplete="off"
                    withCloseIcon
                    onCloseClick={onCloseClick}
                />
                {openMenu && (
                    <div className="search-bar-menu">
                        <SearchBarOptions
                            error={error}
                            isLoading={isLoading}
                            results={results}
                            inputValue={inputValue}
                        />
                    </div>
                )}
            </button>
            {error && <span className="error-message">{error}</span>}
        </>
    );
};

export default SearchBarInput;
